import React from 'react';
import Avatar from '@atlaskit/avatar';
import { SimpleTag as Tag } from '@atlaskit/tag';
import propTypes from 'prop-types';
const UserDetails = ({ email, name, avatarUrl, showIcTag }) => {
    return (
        <div className="user-details">
            <div>
                <Avatar
                    appearance="circle"
                    src={avatarUrl}
                    name={name}
                    size="medium"
                />
            </div>
            <div className="user-info">
                <div className="user-name">{name}</div>
                <div className="user-email">{email}</div>
                {showIcTag ? (
                    <div className="user-ic-tag">
                        <Tag
                            text="ISOLATED CLOUD"
                            appearance="rounded"
                            color="orange"
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

UserDetails.propTypes = {
    email: propTypes.string,
    name: propTypes.string,
    avatarUrl: propTypes.string,
    showIcTag: propTypes.bool
};

export default UserDetails;
